var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4713 4.86201C12.7317 5.12236 12.7317 5.54447 12.4713 5.80482L7.13799 11.1382C6.87764 11.3985 6.45553 11.3985 6.19518 11.1382L3.52851 8.47149C3.26816 8.21114 3.26816 7.78903 3.52851 7.52868C3.78886 7.26833 4.21097 7.26833 4.47132 7.52868L6.66659 9.72394L11.5285 4.86201C11.7889 4.60166 12.211 4.60166 12.4713 4.86201Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.b5b9c238ab25bcdd8963e01c7d88ee05.svg";
export { ForwardRef as ReactComponent };